import React from 'react';
import {ProfilePage} from "../../components";

const Profile = () => {
    return <ProfilePage/>;
};

export default Profile;